/* eslint-disable react/display-name */
import React, { forwardRef, useContext} from 'react'
import OptionsContext from '../../utils/OptionsContext'
import btnSound from '../../assets/sounds/fx/14-button.mp3'
import largeBtnSound from '../../assets/sounds/fx/15-button-large.mp3'
import styles from './Button.module.scss'
import useSound from 'use-sound'

const Button = forwardRef(function Button(
  {
    as: Component = 'button',
    children,
    onClick,
    size = 'medium',
    variant = 'primary',
    uppercase = false,
    hasOwnSound = false,
    ...otherProps
  },
  ref
) {

  const {
    playSoundEffect,
    options: { effectsVolume },
  } = useContext(OptionsContext)
  const sound = variant === 'huge' ? largeBtnSound : btnSound
  // TODO: use same volume when we have more even fx volumes
  const volume = variant === 'huge' ? effectsVolume - 0.1 : effectsVolume
  const [playSound] = useSound(sound, { volume: volume })


  function renderSize() {
    let cssSize = size
    variant === 'huge' ? (cssSize = 'xlarge') : (cssSize = size)
    return cssSize
  }

  function handleClick() {
    !hasOwnSound && playSoundEffect(playSound)
    onClick && onClick()
  }

  return (
    <Component
      {...(ref ? { ref } : {})}
      onClick={handleClick}
      className={`${styles.button} ${styles[variant]} ${styles[renderSize()]} ${uppercase && styles.uppercase} ${styles.ripple}`}
      {...otherProps}
    >
      {children}
    </Component>
  )
})

export default Button
